import { sendTagOnError } from "app/utils/analytics";
import {
	FETCH_PROFILE_FAILURE,
	FETCH_PROFILE_REQUEST,
	FETCH_PROFILE_SUCCESS,
	SAVE_NEWSLETTER_PREFERENCES,
} from "app/actionTypes";
import getHistory from "app/configureHistory";
import { logout } from "app/pages/Auth/AuthActions";
import pruneEmpty from "app/utils/pruneEmpty";
import env from "app/utils/env";
import { SET_NEWSLETTER_FREQUENCY_MODAL_VIEWED } from "app/pages/Account/Subscriptions/subscriptionsActionTypes";
import axios from "app/utils/http/http";

export const postSubscriptions = data => {
	const _data = pruneEmpty(data);

	const params = {};
	if (_data.silent) {
		// permet de ne pas envoyer d'email de modification de compte et d'harceler le client
		params.silent = true;
		delete _data.silent;
	}
	return {
		type: SAVE_NEWSLETTER_PREFERENCES,
		promise: axios.post(env("USER_AUTH_API_URL") + "/me", _data, {
			headers: {
				"Content-type": "application/json",
			},
			params,
		}),
	};
};

export const setNewsletterFrequencyModalViewed = () => {
	return {
		type: SET_NEWSLETTER_FREQUENCY_MODAL_VIEWED,
	};
};

export const getSubscriptions = () => {
	return dispatch => {
		const url = env("USER_AUTH_API_URL") + "/me";

		dispatch({
			type: FETCH_PROFILE_REQUEST,
		});

		axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PROFILE_SUCCESS,
					profile: res.data,
				});
			})
			.catch(err => {
				if (
					err &&
					err.response &&
					err.response.status &&
					(err.response.status === 401 || err.response.status === 403)
				) {
					dispatch(logout());
					getHistory().replace("/home/login");

					sendTagOnError(`Get ${url} : ${err.message} - ${err.response.data.message}`);
				} else {
					dispatch({
						type: FETCH_PROFILE_FAILURE,
					});

					sendTagOnError(`${url} : ${err.message}`);
				}
			});
	};
};
